'use client';

import type { Listing } from '@ps/models/lib/listing';

import { useVariantQuantity } from '../contexts/variant-quantity/context';
import { VariantPicker } from './VariantPicker';

type VariantPickerRowProps = {
  listing: Pick<Listing, 'variants' | 'skuAttributes' | 'quantity'>;
};

/**
 * Variant picker wired to the PDP context. Renders nothing outside the
 * provider or when the listing has no variants. Mirrors RN's variants row
 * (the `events$`/error-chip/`flash()` plumbing is deferred — it's only
 * driven by Buy-click validation, which lives in the deferred checkout flow).
 */
export function VariantPickerRow({ listing }: VariantPickerRowProps) {
  const ctx = useVariantQuantity();
  if (!ctx || !ctx.hasVariants) return null;

  return (
    <VariantPicker
      listing={listing}
      selection={ctx.selection}
      onSelectAttr={ctx.onSelectAttr}
      hideSingleVariant
    />
  );
}
